// extracted by mini-css-extract-plugin
module.exports = {"youTubePlayer":"_3NOKeYUiCFPu7c4u5SttJ9","playeroverlay":"xXun6po1n_8sfpxO7PT32"};